<div class="margin-content mt-5">
  <h3 i18n class="fs-3 text-center fw-semibold mb-3">
    This platform is powered by PeerTube
  </h3>

  <img class="d-block my-4 mx-auto" width="121px" height="147px" src="/client/assets/images/mascot/default.svg" alt="mascot"/>

  <div class="text-center">
    <p i18n>
      PeerTube is a self-hosted ActivityPub-federated video streaming platform using P2P directly in your web browser.
    </p>

    <p i18n>
      It is free and open-source software, under <a class="link-primary" href="https://github.com/Chocobozzz/PeerTube/blob/develop/LICENSE">AGPLv3
      licence</a>.
    </p>

    <p i18n>
      For more information, please visit <a class="link-primary" target="_blank" rel="noopener noreferrer" href="https://joinpeertube.org">joinpeertube.org</a>.
    </p>
  </div>

  <div class="d-flex flex-wrap justify-content-center my-5">

    <div class="card">
      <div class="card-body">
        <div class="card-title">
          <a i18n class="link-primary" target="_blank" rel="noopener noreferrer" href="https://docs.joinpeertube.org/use/setup-account">Use PeerTube documentation</a>
        </div>

        <div i18n class="card-text">
          Discover how to setup your account, what is a channel, how to create a playlist and more!
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <div class="card-title">
          <a i18n class="link-primary" target="_blank" rel="noopener noreferrer" href="https://docs.joinpeertube.org/use/third-party-application">PeerTube Applications</a>
        </div>

        <div i18n class="card-text">
          Discover unofficial Android applications or browser addons!
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <div class="card-title">
          <a i18n class="link-primary" target="_blank" rel="noopener noreferrer" href="https://docs.joinpeertube.org/contribute/getting-started">Contribute on PeerTube</a>
        </div>

        <div i18n class="card-text">
          Want to help to improve PeerTube? You can translate the web interface, give your feedback or directly contribute to the code!
        </div>
      </div>
    </div>
  </div>
</div>
